// Wildcard acceleration V1; 2026-10-29 22:12 CST; parent c318343319b6812e0aba7ab02fbf64b65aca0196.
/** HTTP-01 cannot validate wildcard certificates; keep ordinary domain requests unchanged. */
export function managedCertificateIdentity(domain: string) {
 const wildcard=domain.startsWith('*.');
 const domainName=wildcard?domain.slice(2):domain;
 if(domainName.includes('*'))throw new Error('只支持域名最左侧的一个泛域名标记');
 return {domainName,wildcard,challengeType:wildcard?'DNS_01' as const:'HTTP_01' as const};
}
